import React from 'react';
import './RawDataBanner.css';

function RawDataBanner({ showRaw, onToggle, loading, loadingMessage }) {
  return (
    <div className="raw-data-controls">
      <label className={`raw-toggle ${loading ? 'raw-toggle-loading' : ''}`}>
        <input
          type="checkbox"
          checked={showRaw}
          onChange={onToggle}
          disabled={loading}
        />
        <span className="raw-toggle-label">
          {loading ? (loadingMessage || 'Fetching PHI from VitalEngine…') : 'Show Raw PHI Data'}
        </span>
        {loading && <span className="raw-toggle-spinner" aria-hidden="true" />}
      </label>
      {showRaw && !loading && (
        <div className="raw-data-banner">
          <span className="raw-banner-icon">&#9888;</span>
          <span>
            <strong>Raw PHI data is displayed.</strong> This data is fetched live from VitalEngine, is not stored locally,
            and will be cleared when you leave this page or toggle off.
          </span>
        </div>
      )}
    </div>
  );
}

export default RawDataBanner;
